export default "__VITE_ASSET__uvYipi4y__"